
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 8a8 8 0 1116 0A8 8 0 010 8zm8-4.267c-1.158 0-1.304.005-1.759.026-.454.02-.764.093-1.035.198-.281.11-.52.255-.756.492a2.094 2.094 0 00-.493.756c-.106.271-.178.582-.198 1.036-.02.455-.026.6-.026 1.759 0 1.159.005 1.304.026 1.759.021.454.093.764.198 1.035.11.281.255.52.492.756.237.238.476.384.756.493.271.105.582.177 1.036.198.455.02.6.026 1.759.026 1.159 0 1.304-.005 1.759-.026.454-.02.764-.093 1.036-.198.28-.11.518-.255.755-.493.238-.237.383-.475.493-.755.105-.272.177-.582.198-1.036.02-.455.026-.6.026-1.759 0-1.159-.006-1.304-.026-1.76-.021-.453-.093-.764-.198-1.035a2.094 2.094 0 00-.493-.756 2.086 2.086 0 00-.755-.492c-.272-.105-.583-.177-1.037-.198-.455-.02-.6-.026-1.759-.026H8zm-.382.77H8c1.14 0 1.275.003 1.725.024.415.019.641.088.792.147.199.077.34.17.49.319.15.15.242.291.32.49.058.15.127.376.146.792.02.45.025.585.025 1.724s-.004 1.274-.025 1.724c-.019.416-.088.641-.147.792-.077.199-.17.34-.319.49a1.32 1.32 0 01-.49.319c-.15.059-.377.128-.792.147-.45.02-.585.025-1.725.025-1.139 0-1.274-.005-1.724-.025-.416-.02-.641-.089-.792-.147-.2-.078-.341-.17-.49-.32a1.322 1.322 0 01-.32-.49c-.058-.15-.128-.376-.147-.792-.02-.45-.024-.585-.024-1.724 0-1.14.004-1.274.024-1.724.02-.416.089-.641.147-.792.077-.199.17-.341.32-.49.149-.15.29-.242.49-.32.15-.058.376-.128.792-.147.394-.018.546-.023 1.342-.024v.001zm2.66.708a.512.512 0 100 1.024.512.512 0 000-1.025zM8 5.809a2.191 2.191 0 100 4.382A2.191 2.191 0 008 5.81zm0 .769a1.422 1.422 0 110 2.844 1.422 1.422 0 010-2.844z","fill":"currentColor"}})])
          )
        }
      }
    